import { render, staticRenderFns } from "./ClearUsersPage.vue?vue&type=template&id=3262287d"
import script from "./ClearUsersPage.vue?vue&type=script&lang=js"
export * from "./ClearUsersPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports